import React from 'react';

import { useNavigationItemActions } from '@atlassian/navigation-drag-and-drop';

import { AnyAri } from '@atlassian/ari/any-ari';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import {
	BoardActions,
	type BoardActionsProps,
} from '@atlassian/jira-navigation-board-action-menu/src/ui/BoardActions.tsx';
import { useDragAndDropReorderingAnalytics } from './drag-and-drop-reorder-analytics.tsx';

type DraggableBoardActionsProps = BoardActionsProps & {
	currentItems: Array<{ id: string; label: string }>;
	currentOrder: Array<{ menuId: string; visible: boolean }>;
	showReorderActions?: boolean;
	projectKey: string;
	ownerAri: string;
	item: {
		id: string;
		label: string;
	};
};

/**
 * The BoardActions menu with options Board Settings and Delete Board.
 * It is displayed in the project board header when there is more than one board in the project
 * and in the sidebar next to each board.
 */
export const DraggableBoardActions = (
	props: DraggableBoardActionsProps,
): React.JSX.Element | null => {
	const { currentItems, currentOrder, item, ownerAri, projectKey, ...rest } = props;
	const { fireAnalyticsEvent } = useDragAndDropReorderingAnalytics();
	const cloudId = useCloudId();
	const entityAri = AnyAri.create({
		cloudId,
		resourceType: 'project',
		resourceId: projectKey,
		resourceOwner: 'jira',
	}).toString();
	const actions = useNavigationItemActions({
		currentItems,
		currentOrder,
		entityAri,
		ownerAri,
		fireAnalyticsEvent,
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		getItemId: (i) => (i as { id: string }).id,
		item,
	});
	return <BoardActions {...rest} reorderActions={actions} />;
};
